import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap';
import buycoin from '../../assets/images/buycoin/buycoin.svg';

import './buycoin_styles/buyupper.css';

export default function BuyUpper() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <div className="buyup">
              <div className="buyup_head d-flex justify-content-center">
                <h2>SELECT BUYING METHOD</h2>
              </div>
              <div className="buyup_btns mt-5">
                <Row>
                  <Col>
                    <Button className='w-100 buyup_btn d-flex align-items-center'>
                     <img src={buycoin} alt="buycoin" className='buy_img' /> <span>BANXA</span> 
                    </Button>
                  </Col>
                  <Col>
                    <Button className='w-100 buyup_btn d-flex align-items-center'>
                     <img src={buycoin} alt="buycoin" className='buy_img' /> <span>SIMPLEX</span> 
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
